import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavService } from '../../service/nav.service';
import { trigger, transition, useAnimation } from '@angular/animations';
import { fadeIn } from 'ng-animate';

@Component({
  selector: 'app-ciudadano-layout',
  templateUrl: './ciudadano-layout.component.html',
  styleUrls: ['./ciudadano-layout.component.scss'],
  animations: [
    trigger('animateRoute', [transition('* => *', useAnimation(fadeIn, {}))])
  ]
})
export class CiudadanoLayoutComponent implements OnInit, OnDestroy {

  public right_side_bar: boolean;
  public layoutType: string = 'RTL';
  public layoutClass: boolean = false;

  constructor(public navServices: NavService) { }

  public getRouterOutletState(outlet) {
    return outlet.isActivated ? outlet.activatedRoute : '';
  }

  public rightSidebar($event) {
    this.right_side_bar = $event;
  }

  public clickRtl(val) {
    if (val === 'RTL') {
      document.body.classList.add('rtl');
      this.layoutClass = true;
      this.layoutType = 'LTR';
    } else {
      document.body.classList.remove('rtl');
      this.layoutClass = false;
      this.layoutType = 'RTL';
    }
  }

  ngOnInit() {
    document.body.classList.add('portal-ciudadano');
  }

  ngOnDestroy() {
    document.body.classList.remove('portal-ciudadano');
  }

}
